'use client';

import React from 'react';

export function AboutNycOpenViolationsModal() {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2 px-2">
        <div className="flex flex-col gap-2 text-body-2 text-secondary rounded-2xl">
          <p>
            A violation is issued to a building when a city inspector from NYC's Department of
            Housing Preservation and Development validates and confirms a complaint made to 311.
          </p>
          <p>
            The violations listed are open violations that are yet to be addressed or have not been
            confirmed as resolved by the city.
          </p>
        </div>
      </div>
    </div>
  );
}
